import { render } from "./SchoolRecords.vue?vue&type=template&id=607ae35f"
import script from "./SchoolRecords.vue?vue&type=script&lang=js"
export * from "./SchoolRecords.vue?vue&type=script&lang=js"

import "./SchoolRecords.vue?vue&type=style&index=0&id=607ae35f&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__